import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HOME_LAYOUT_HEIGHT, HOME_LAYOUT_WIDTH } from "../../app/common";
import LoadingSpinner from "../../common/components/functional/loadingSpinner/LoadingSpinner";

type Props = {
  isLoading: boolean;
};

const TalentEmptyState = ({ isLoading }: Props) => {
  const { t } = useTranslation("talentProfile");

  return (
    <>
      {isLoading ? (
        <LoadingSpinner
          sx={{
            height: HOME_LAYOUT_HEIGHT,
            width: HOME_LAYOUT_WIDTH,
          }}
        />
      ) : (
        <Typography>{t("talentNotFound")}</Typography>
      )}
    </>
  );
};

export default TalentEmptyState;
